module.exports = __webpack_public_path__ + "img/eye_icon.0d6b05bb.png";